var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-heigth", staticStyle: { padding: "15px" } },
    [
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          staticStyle: { display: "flex" },
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: { placeholder: "請輸入場次代號 / 場次名稱" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearch($event)
                  },
                },
                model: {
                  value: _vm.listQuery.search.query,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery.search, "query", $$v)
                  },
                  expression: "listQuery.search.query",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { margin: "8px 0 0 8px" } },
            [
              _c("el-button", {
                attrs: {
                  type: "primary",
                  icon: "el-icon-search",
                  circle: "",
                  loading: _vm.loading,
                },
                on: { click: _vm.handleSearch },
              }),
              _c("el-button", {
                attrs: {
                  type: "success",
                  icon: "el-icon-refresh-left",
                  circle: "",
                  loading: _vm.loading,
                },
                on: { click: _vm.handleRefresh },
              }),
              _c("el-button", {
                attrs: {
                  type: "warning",
                  icon: "el-icon-plus",
                  circle: "",
                  loading: _vm.loading,
                },
                on: { click: _vm.handleCreate },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.gameList,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "calc(80vh - 180px)",
                "overflow-x": "auto",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.listQuery.page - 1) * _vm.listQuery.limit +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "場次代號",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.code))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "場次名稱", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "設定網址",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.editorUrl
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCopyLink(
                                      scope.row.editorUrl,
                                      $event
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(" 複製網址 "),
                                _c("i", {
                                  staticClass: "el-icon-copy-document",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "遊玩網址",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.playerUrl
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCopyLink(
                                      scope.row.playerUrl,
                                      $event
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(" 複製網址 "),
                                _c("i", {
                                  staticClass: "el-icon-copy-document",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "建立時間",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.listQuery.total > 0,
                expression: "listQuery.total > 0",
              },
            ],
            attrs: {
              layout: "prev, pager, next",
              total: _vm.listQuery.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.handlePagination,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogForm.id ? "編輯場次" : "建立場次",
            visible: _vm.dialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogForm",
              attrs: {
                model: _vm.dialogForm,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "場次代號",
                    prop: "code",
                    rules: [
                      {
                        required: true,
                        message: "請輸入場次代號",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "請輸入場次代號",
                      disabled: _vm.dialogForm.id,
                    },
                    model: {
                      value: _vm.dialogForm.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "code", $$v)
                      },
                      expression: "dialogForm.code",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "場次名稱",
                    prop: "name",
                    rules: [
                      {
                        required: true,
                        message: "請輸入場次名稱",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "請輸入場次名稱" },
                    model: {
                      value: _vm.dialogForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "name", $$v)
                      },
                      expression: "dialogForm.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.submitLoading,
                  },
                  on: { click: _vm.handleDialogSave },
                },
                [_vm._v(" 確定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }